//FIXME HARDCODED FUNCTION
export const getNotifications = () => {
  return [
    {
      type: "Aviso",
      description: "Conta inativa, por favor contacte o seu gestor",
    },
  ];
};
